import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MarketplaceEmptyIllustration from '../../../../assets/images/marketplace-empty.svg';
import { MarketplaceStatuses } from '../../../../constants/marketplaceStatuses';
import { CashbackBanner } from '../../../../shared/components/cashbackBanner';
import { TextWrapper } from '../../../../shared/components/formUtilities/useTextWrapper';
import { MarketplaceLoader } from '../../../../shared/components/investors/loaders/marketplaceLoader';
import { MarketplaceItems } from './marketplaceItem';
import { MarketplaceService } from './marketplaceService';

export const Marketplace = () => {
	const marketplaceService = new MarketplaceService();

	const [marketplaceItems, setMarketplaceItems] = useState([]);
	// const [collectionItems, setCollectionItems] = useState([]);
	const [pastMarketplaceItems, setPastMarketplaceItems] = useState([]);
	const [topOffset, setTopOffset] = useState(0);
	// const [opportunitiesCount, setOpportunitiesCount] = useState(0);
	const [loading, setLoading] = useState(true);

	const { t } = useTranslation();

	useEffect(() => {
		getAllOpportunities();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onCashackLayoutChange = () => {
		if (loading) return;

		const element = document.getElementById("mp-announcement-bar");
		if (!element) return;

		const updateHeight = () => {
			setTopOffset(element.getBoundingClientRect().height + 3);
		};

		// Initial height update
		updateHeight();

		// Observe changes in height dynamically
		const resizeObserver = new ResizeObserver(() => {
			requestAnimationFrame(updateHeight); // Ensures smoother updates
		});
		resizeObserver.observe(element);
	};

	const getAllOpportunities = async () => {
		setLoading(true);
		try {
			const [
				marketplaceItems,
				// collectionItems,
				pastMarketplaceItems,
				// opportunitiesCount,
			] = await Promise.all([
				marketplaceService.getMarketplace(),
				// marketplaceService.getMarketplaceCollection(),
				marketplaceService.getMarketplaceHistory(true),
				// marketplaceService.getOpportunitiesCount(),
			]).catch((err) => {
				setLoading(false);
			});
			let marketplaceActive = marketplaceItems.data;
			// let collectionActive = collectionItems?.data;
			if (marketplaceItems.data && marketplaceItems.data?.length) {
				marketplaceActive = marketplaceItems.data.filter(resp => resp?.showInMarketPlace);
			}
			// if (collectionItems.data && collectionItems.data?.length) {
			// 	collectionActive = collectionItems.data.filter(resp => resp?.showInMarketPlace);
			// }
			setMarketplaceItems(marketplaceActive);
			// setCollectionItems(collectionActive);
			setPastMarketplaceItems(pastMarketplaceItems.data);
			// setOpportunitiesCount(opportunitiesCount.data);
			setLoading(false);
		} catch { }
	};

	const checkRatingA = () => {
		let isRatingA = false;

		// if (collectionItems.length) {
		// 	isRatingA = collectionItems.find((resp) => resp.rating === 'A');
		// }

		if (marketplaceItems.length && !isRatingA) {
			isRatingA = marketplaceItems.find((resp) => resp.rating === 'A');
		}


		return isRatingA;
	};

	return (
		<Box className="grid grid-flow-row gap-4" sx={{ marginTop: `${topOffset}px` }}>
			{!loading && marketplaceItems?.length ? <CashbackBanner onLayoutChange={() => onCashackLayoutChange()} /> : null}
			<Box className="grid grid-cols-1 md:grid-cols-3 gap-3">
				{!loading ? (
					<>
						{/* {collectionItems?.length
							? collectionItems?.map((item, index) => {
								return (
									<MarketplaceItems
										key={index}
										isCollection={true}
										item={item}
										status={MarketplaceStatuses.Current}></MarketplaceItems>
								);
							})
							: null} */}
						{marketplaceItems?.length
							? marketplaceItems?.map((item, index) => {
								return (
									<MarketplaceItems
										key={index}
										isCollection={false}
										item={item}
										status={MarketplaceStatuses.Current}></MarketplaceItems>
								);
							})
							: null}
					</>
				) : (
					[1, 2, 3, 4, 5, 6].map((resp) => {
						return <MarketplaceLoader key={resp}></MarketplaceLoader>;
					})
				)}
			</Box>
			{!marketplaceItems?.length && !loading ? (
				<Box className="flex flex-col md:flex-row items-center justify-between gap-8 py-6">
					<TextWrapper
						classList="!text-3xl !font-bold max-w-[320px]"
						text={t('currentlyNoBusinesses')}
					/>
					<img
						src={MarketplaceEmptyIllustration}
						alt="No current opportunities"
						className="w-full max-w-[620px]"
					/>
				</Box>
			) : null}
			<Box>
				{checkRatingA() ? (
					<TextWrapper
						type="caption"
						text={t('shamsMoreInfo')}></TextWrapper>
				) : (
					''
				)}
			</Box>
			{!marketplaceItems?.length ? (
			<Box className="mt-7 grid grid-flow-row gap-4">
				<Box className='flex flex-col'>
					<TextWrapper
						classList="!heading !text-investor-deep"
						text={t('pastOpportunities')}></TextWrapper>
					{pastMarketplaceItems?.length ? <TextWrapper classList='!text-[14px] !text-investor-deep' text={
						<span>
							{t('recentOpportunityInfoText')}
						</span>
					} /> : null}
				</Box>
				<Box className="grid grid-cols-1 md:grid-cols-3 gap-3">
					{!loading ? (
						<>
							{pastMarketplaceItems?.length
								? pastMarketplaceItems?.map((item, index) => {
									return (
										<MarketplaceItems
											key={index}
											isCollection={false}
											item={item}
											status={MarketplaceStatuses.Past}></MarketplaceItems>
									);
								})
								: null}
						</>
					) : (
						[1, 2, 3, 4, 5, 6].map((resp) => {
							return <MarketplaceLoader key={resp}></MarketplaceLoader>;
						})
					)}
				</Box>

			</Box>
			) : null}
			{/* <Box>
				{pastMarketplaceItems?.length && !loading ? (
					<>
						{t('moreThanOther')} <strong>{opportunitiesCount}</strong>{' '}
						{t('opportunities')}
					</>
				) : null}
			</Box> */}
		</Box>
	);
};
